import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'form', 'formPartial', 'button'];

  onSelect() {
    // Clear all the form fields, but remember the select value
    const rememberSelectValue = this.selectTarget.value;
    this.resetForm();
    this.selectTarget.value = rememberSelectValue;

    this.updateForm();
  }

  reset() {
    this.resetForm();
    this.updateForm();
  }

  resetForm() {
    this.formTarget.reset();

    this.formTarget.querySelectorAll('input,select').forEach((input) => {
      if (input.type === 'radio' || input.type === 'checkbox')
        input.checked = false;
      else input.value = '';

      // Reset TomSelect instances if present
      if (input.classList.contains('tomselected') && input.tomselect) {
        input.tomselect.clear();
      }
    });

    // Find all TomSelect instances and clear them
    document.querySelectorAll('.ts-wrapper').forEach((wrapper) => {
      const select = wrapper.querySelector('select');
      if (select && select.tomselect) {
        select.tomselect.clear();
      }
    });
  }

  updateForm() {
    this.formPartialTargets.forEach((formPartial) =>
      formPartial.classList.add('hidden'),
    );

    this.formPartialTargets.forEach((formPartial) => {
      if (formPartial.dataset.criterion === this.selectTarget.value) {
        formPartial.classList.remove('hidden');
      }
    });

    this.updateButtons();
  }

  updateButtons() {
    // Check if the form is completed
    let completed = false;

    this.formPartialTargets.forEach((formPartial) => {
      if (formPartial.dataset.criterion === this.selectTarget.value) {
        // Special handling for yongShenMentalPattern
        if (formPartial.dataset.criterion === 'yongShenMentalPattern') {
          completed = this.validateYongShenMentalPattern(formPartial);
        } else {
          [...formPartial.querySelectorAll('input,select')].every((input) => {
            if (input.type === 'radio' || input.type === 'checkbox') {
              if (input.checked) completed = true;
            } else {
              if (
                input.dataset.required == 'true' &&
                input.value.length === 0
              ) {
                completed = false;
                return false;
              }

              if (input.value.length > 0) completed = true;
            }

            return true;
          });
        }
      }
    });

    this.buttonTargets.forEach((button) => (button.disabled = !completed));
  }

  validateYongShenMentalPattern(formPartial) {
    // For yongShenMentalPattern, we need at least one radio button checked
    // AND at least one checkbox checked for that radio button's option
    const radios = formPartial.querySelectorAll('input[type="radio"]');

    for (const radio of radios) {
      if (radio.checked) {
        // Find checkboxes for this radio's option
        const optionKey = radio.value;
        const checkboxGroup = formPartial.querySelector(
          `[data-option-key="${optionKey}"]`,
        );

        if (checkboxGroup) {
          const checkboxes = checkboxGroup.querySelectorAll(
            'input[type="checkbox"]',
          );
          const hasCheckedCheckbox = Array.from(checkboxes).some(
            (checkbox) => checkbox.checked,
          );

          if (hasCheckedCheckbox) {
            return true; // Valid: radio checked with at least one checkbox
          }
        }
      }
    }

    return false; // No valid combination found
  }

  changeOtherRequired(event) {
    if (!event.target.dataset.other) return;

    const other = document.getElementById(event.target.dataset.other);

    if (event.target.value) other.dataset.required = 'false';
    else other.dataset.required = 'true';
  }
}
